export const DOCUMENT_TYPE_INSURANCE_AREA = 'insurance-area';
